import {useEffect, useState} from 'react'
import { image } from '../../../app/utils/common/image'
import { useNavigate } from 'react-router-dom';
import UserManagementTable from '../../molecules/UserManagement/UserManagementTable';
import { checkPermission, permissionType } from '../../../app/utils/common/checkPermission';
import FilterModal from '../../atoms/FilterModal/FilterModal';
import { setUserManagementFilter, setUserManagementLoading, setUsersManagementPagination } from '../../../redux/Slices/allUsersSlice';
import { useAppDispatch, useAppSelector } from '../../../app/utils/hooks/reduxHook';
import { getAllUserManagementAPI } from '../../../redux/API/AllUsersAPI';
import { getAllRoles } from '../../../redux/API/RoleAPI';

const UserManagement = () => {
   const navigate = useNavigate();
  const [filterModal, setFilterModal] = useState<boolean>(false);
  const { userManagementFilter,  userManagementPagination } = useAppSelector(state => state.allUsers)
  const { allRoles } = useAppSelector(state => state.role)
  const { searchText } = useAppSelector(state => state.search);
  const dispatch = useAppDispatch();

  const filterModalOptions = allRoles.filter(role => role.role_id !== 2 && role.role_id !== 3).map(role => ({
    key: role.role_id,  
    value: role.role_name,
  }));

   const fetchFilterData = (sortBy: any) => {
     dispatch(setUserManagementFilter(sortBy))
     dispatch(setUsersManagementPagination({ ...userManagementPagination, current_page: 1 }));
     dispatch(getAllUserManagementAPI({ page: 1, sortBy, searchText, filterBy: "active" })).unwrap().then(() => {
     dispatch(setUserManagementLoading(false));
    })
  }

  useEffect(() => {
    if (checkPermission(permissionType.ROLE_MANAGEMENT, "read")) {
      dispatch(getAllRoles());
    }
},[dispatch])

  return (
    <div className='manager_container'>
    <div className='manager_header'>
        <div className='allManager'>
            User Management
        </div>
          {checkPermission(permissionType.USER_MODULE, "create") && 
            <div className='button_container'>
               <div className='btn' onClick={() => setFilterModal(!filterModal)}>
                            {(userManagementFilter !== "" || null || undefined) && <div className='filter_count'><span>1</span></div>}
                            <img className='btn_icon' src={image.FILTER_ICON} />
                            <div>
                                Filter
                            </div>
                        </div>
                <div className='btn' onClick={() => { navigate('user/create') }}>
                    <img className='btn_icon' src={image.ADD_ICON} />
                    <div>
                        Add
                    </div>
                  </div>
            </div>
          }
    </div>

    <div className='manager_data_table'>
        <UserManagementTable />
      </div>
      {filterModal && (
                <div className='filter_modal_wrapper'>
                    <FilterModal
                        options={filterModalOptions}
                        selectedFilter={userManagementFilter}
                        handleSubmit={(data) => {
                            fetchFilterData(data.key);
                            setFilterModal(false);
                        }}
                        handleRemoveFilter={() => {
                            dispatch(setUserManagementFilter(''));
                            dispatch(setUsersManagementPagination({...userManagementPagination, current_page: 1}))
                            dispatch(getAllUserManagementAPI({ page: 1, limit: 15, filterBy:"active" }))
                            setFilterModal(false);
                        }}
                        // filterType="user"
                        onOutSideClick={() => setFilterModal(false)} 
                    />
                </div>
            )}
      

</div >
  )
}
export default UserManagement
